// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"1f5e9b1d","199":"23425166","309":"ca9df91e","517":"be0142dc","608":"23425166","609":"ab7c80b0","623":"88fd52e6","798":"2c51b313","875":"88fd52e6","921":"d25fd829"}[chunkId] + ".chunk.css";
};